import { css } from '@emotion/react';

export const navCss = css`
  white-space: nowrap;
`;

export const navItemCss =
  ({ active, dropdown, locked, readOnly }) =>
  (theme) =>
    [
      css`
        background-color: ${theme.color.black};
        border: none;
        border-radius: 0;
        display: inline-block;
        width: 90px;
        height: 90px;
        outline: none;
        text-align: center;
        text-decoration: none !important;
        vertical-align: middle;
        &:hover {
          background-color: rgba(0, 0, 0, 0.4);
        }
      `,
      active &&
        css`
          background: none !important;
        `,
      dropdown &&
        css`
          position: relative;
          .nav-item__toggle {
            background: none !important;
            border: none;
            width: 100%;
            height: 100%;
          }
          .nav-item__menu {
            padding: 8px;
            width: 420px;
            white-space: normal;

            :before {
              position: absolute;
              top: -7px;
              left: 9px;
              display: inline-block;
              border-right: 7px solid transparent;
              border-bottom: 7px solid #ccc;
              border-left: 7px solid transparent;
              border-bottom-color: rgba(0, 0, 0, 0.2);
              content: '';
            }
            :after {
              position: absolute;
              top: -6px;
              left: 10px;
              display: inline-block;
              border-right: 6px solid transparent;
              border-bottom: 6px solid #ffffff;
              border-left: 6px solid transparent;
              content: '';
            }
          }
          .nav-item__menu-label {
            padding: 8px;
          }
          .nav-item__menu-item {
            background-color: ${theme.color.gray};
            border-radius: 50%;
            color: ${theme.color.white};
            display: inline-block;
            line-height: 32px;
            margin: 4px;
            text-align: center;
            width: 32px;
          }
          .nav-item__menu-item--active {
            background-color: ${theme.color.warning};
          }
        `,
      locked &&
        css`
          cursor: auto;
          pointer-events: none;
          &:hover {
            background-color: ${theme.color.black};
          }
        `,
      readOnly &&
        css`
          pointer-events: none;
        `,
    ];

export const labelCss =
  (active, locked, warning) =>
  ({ color }) =>
    [
      css`
        background-color: ${color.primary};
        border-radius: 50%;
        color: inherit;
        display: block;
        line-height: 32px;
        width: 32px;
        text-align: center;
        font-size: 18px;
        margin: auto;
      `,
      active &&
        css`
          background-color: ${color.white};
          color: ${color.text};
        `,
      !active &&
        !locked &&
        css`
          background-color: ${color.white};
          color: ${color.text};
        `,
      locked &&
        css`
          background-color: ${color.gray};
          color: ${color.white};
        `,
      warning &&
        css`
          background-color: ${color.warning};
          color: ${color.white};
        `,
    ];
